import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { message } from "antd";
import Table from "../../core/common/dataTable/index";
import { all_routes } from "../router/all_routes";
import DatePicker from "react-datepicker";
import { termination } from "../../core/common/selectoption/selectoption";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../core/data/redux/store";
import {
  getEmployees,
  getEmployeeById,
} from "../../core/data/redux/employee/employeeAction";
import {
  fetchAllDepartments,
} from "../../core/data/redux/department/departmentAction";
import {
  fetchAllDesignations,
  fetchDesignationById,
} from "../../core/data/redux/designation/designationAction";
import {
  createResignation,
  fetchAllResignations,
  Updateresignation,
  deleteResignation,
  fetchEmployeeDetailsById,
  getAllHODsAndHr,
} from "../../core/data/redux/resignation/resignationAction";
import DeleteModal1 from "../../core/modals/deleteModal1";
import { formatDate } from "../../core/utils/configFormatters";
import dayjs from 'dayjs';
import { Drawer } from "antd";
import { filterData } from "../../core/common/GlobalFunctions/tableFilters";
import { useAppConfig } from "../../customhooks/useAppConfig";
import { decryptData } from "../../core/utils/encryptUtils";
import { filterByStatus } from "../../core/utils/filterActiveData";

interface ResignationFormProps {
  initialData?: {
    employee: any;
    department: any;
    designation: any;
    manager: any;
    hod_id: any;
    hrId: any;
    noticeDate: Date | null;
    resignationDate: Date | null;
    reason: string;
  };
}

const Resignation: React.FC<ResignationFormProps> = ({ initialData }) => {
  const dispatch = useDispatch<AppDispatch>();
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
  const { employees } = useSelector((state: any) => state.employee);
  const { departments } = useSelector((state: any) => state.department);
  const { designations } = useSelector((state: any) => state.designation);
  const [isEditing, setIsEditing] = useState(false);
  const { resignation, loadingStates } = useSelector((state: any) => state.resignation);
  const isLoading = isEditing ? loadingStates.update : loadingStates.create;
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
  const [selectedRowData, setSelectedRowData] = useState<any>();
  const employeeId = selectedRowData?.Id;
  const { user } = useSelector((state: any) => state.auth);
  const getAllHodAndHr = useSelector((state: any) => state.resignation.getAllHodAndHr);

  useEffect(() => {
    dispatch(getAllHODsAndHr());
  }, [dispatch])

  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [tableKey, setTableKey] = useState(0);


  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];


  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");


  const handleDelete = (terminationId: any) => {
    const employeeId = terminationId;
    dispatch(deleteResignation(employeeId))
      .then((resp: any) => {
        if (resp.meta.requestStatus === "fulfilled") {
          setIsDeleteModalVisible(false);
          message.success(resp.payload.message);
          dispatch(fetchAllResignations());
        } else {
          setIsDeleteModalVisible(false);
          message.warning(resp.payload.message);
        }
      })
      .catch((error: any) => {
        console.error("error is ", error);
      });
  };

const handleEdit = (record: any): void => {
  setIsEditing(true);
  setSelectedRowData(record);
  const employeeOpt = formattedEmployees.find((opt: any) => opt.label.toLowerCase() === record.Resigning_Employee?.toLowerCase());
  const departmentOpt = formattedDepartment.find((opt: any) => opt.label.toLowerCase() === record.Department?.toLowerCase());
  const designationOpt = formattedDegination.find((opt: any) => opt.label.toLowerCase() === record.Designation?.toLowerCase());
  const managerOpt = formattedEmployees.find((opt: any) => opt.label.toLowerCase() === record.ManagerName?.toLowerCase());
  const hodOpt = formattedHOD.find((opt: any) => opt.label.toLowerCase() === record.HODName?.toLowerCase());
  const hrOpt = formattedHr.find((opt: any) => opt.label.toLowerCase() === record.HRName?.toLowerCase());

  setFormData({
    employee: employeeOpt?.value || "",
    department: departmentOpt?.value || "",
    designation: designationOpt?.value || "",
    manager: managerOpt?.value || "",
    hod_id: hodOpt?.value || "",
    hrId: hrOpt?.value || "",
    noticeDate: record.Notice_Date ? dayjs(record.Notice_Date).toDate() : null,
    resignationDate: record.Resignation_Date ? dayjs(record.Resignation_Date).toDate() : null,
    modifiedBy: user?.UserId,
  });
};


  const activeEmplpoyee = filterByStatus(employees, "active", "employee_status");
  const activeDepartment = filterByStatus(departments, "active", "Status");
  const activeDesignations = filterByStatus(designations, "active", "DesignationStatus");

  const formattedEmployees = activeEmplpoyee.map((emp: any) => ({
    value: emp.EmployeeID,
    label: emp.Name,
  }));

  const formattedDepartment = activeDepartment.map((emp: any) => ({
    value: emp.Id,
    label: emp.Name,
  }));

  const formattedDegination = activeDesignations.map((emp: any) => ({
    value: emp.DesignationId,
    label: emp.DesignationName,
  }));

const hodList = getAllHodAndHr?.hods || [];
const hrList = getAllHodAndHr?.hrs || [];

const formattedHOD = hodList.map((hod: any) => ({
  value: hod.EmployeeID,
  label: hod.Name,
}));

const formattedHr = hrList.map((hr: any) => ({
  value: hr.hrId,
  label: hr.hrName,
}));

  const [formData, setFormData] = useState<any>({
    employee: "",
    department: "",
    designation: "",
    manager: "",
    hrId: "",
    hod_id: "",
    noticeDate: "",
    resignationDate: "",
    createdBy: user?.UserId,
  });


  useEffect(() => {
    if (formData.employee) {
      dispatch(fetchEmployeeDetailsById(formData.employee))
        .then((res: any) => {
          const data = res?.payload?.data;

          if (data) {
            const department = formattedDepartment.find(
              (opt: any) => opt.label.toLowerCase() === data.DepartmentName?.toLowerCase()
            );

            const designation = formattedDegination.find(
              (opt: any) => opt.label.toLowerCase() === data.DesignationName?.toLowerCase()
            );

            const manager = formattedEmployees.find(
              (opt: any) => opt.label.toLowerCase() === data.SupervisorName?.toLowerCase()
            );

            const hodOpt = formattedHOD.find((opt: any) => opt.value === data.hod_id);
            const hrOpt = formattedHr.find((opt: any) => opt.value === data.hrId);

            setFormData((prev: any) => ({
              ...prev,
              department: department?.value || "",
              designation: designation?.value || "",
              manager: manager?.value || "",
              hod_id: hodOpt?.value || "",
              hrId: hrOpt?.value || "",
            }));
          }
        });
    }
  }, [formData.employee]);


  const handleChange = (key: string, value: any) => {
    setFormData((prev: any) => ({
      ...prev,
      [key]: value?.value ?? value,
    }));
  };

  const validateForm = () => {
    if (!formData.employee) {
      message.error("Please select an employee");
      return false;
    }
    if (!formData.department) {
      message.error("Please select a department type");
      return false;
    }
    if (!formData.designation) {
      message.error("Please select a designation type");
      return false;
    }
    if (!formData.manager) {
      message.error("Please select a designation type");
      return false;
    }
    if(!formData.hod_id){
      message.error("Please select a hod");
      return false;
    }
    if (!formData.noticeDate) {
      message.error("Please select a notice date");
      return false;
    }
    if (!formData.resignationDate) {
      message.error("Please select a resignation date");
      return false;
    }
    if (formData.resignationDate > formData.noticeDate) {
      message.error("resignation date cannot be after the notice date.");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) return;

    const payloadData = {
      ...formData,
      noticeDate: formData.noticeDate ? dayjs(formData.noticeDate).format('YYYY-MM-DD') : null,
      resignationDate: formData.resignationDate ? dayjs(formData.resignationDate).format('YYYY-MM-DD') : null,
      createdBy: user?.UserId,
    };

    if (isEditing) {
      dispatch(Updateresignation({ employeeId, data: formData })).then(
        (res) => {
          if (res.meta.requestStatus === "fulfilled") {
            message.success(res.payload.message);
            setIsDrawerVisible(false);
            setFormData({
              employee: "",
              department: "",
              designation: "",
              manager: "",
              hod_id: "",
              noticeDate: "",
              resignationDate: "",
              createdBy: user?.UserId,
            });
            dispatch(fetchAllResignations());
          } else {
            message.warning(res.payload.error);
          }
        }
      );
    } else {
      dispatch(createResignation(payloadData)).then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          message.success(res.payload.message);
          setFormData({
            employee: "",
            department: "",
            designation: "",
            manager: "",
            hod_id: "",
            noticeDate: "",
            resignationDate: "",
            createdBy: user?.UserId,
          });
          setIsDrawerVisible(false);
          dispatch(fetchAllResignations());
        } else {
          message.warning(res.payload.message);
        }
      });
    }
  };



  useEffect(() => {
    dispatch(getEmployees());
    dispatch(fetchAllDepartments());
    dispatch(fetchAllDesignations());
    dispatch(fetchAllResignations());
  }, []);

  const data = resignation;

  const filteredData = useMemo(() => {
    return filterData(data || [], {}, "CreatedAt", "CreatedAt", selectedSort);
  }, [dispatch, resignation, selectedSort, selectedStatus]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [dispatch, resignation, selectedSort, selectedStatus]);



  const config = useAppConfig();
  if (!config) return null;



  const columns = [
    {
      title: "Employee Name",
      dataIndex: "Resigning_Employee",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center">
          {/* <Link to={all_routes.resignation} className="avatar avatar-md me-2">
                        <ImageWithBasePath
                            src={`assets/img/users/${record.Image}`}
                            className="rounded-circle"
                            alt="user"
                        />
                    </Link> */}
          <h6 className="fw-medium">
            <Link to={all_routes.resignation}>{record.Resigning_Employee}</Link>
          </h6>
        </div>
      ),
      sorter: (a: any, b: any) =>
        a.Resigning_Employee.length - b.Resigning_Employee.length,
    },
    {
      title: "Department",
      dataIndex: "Department",
      sorter: (a: any, b: any) => a.Department.length - b.Department.length,
    },
    {
      title: "Notice Date",
      dataIndex: "Notice_Date",
      render: (text: string) => {
        if (!text) return "-";
        const date = new Date(text);
        date.setDate(date.getDate());
        return formatDate(date, config);
      },
      sorter: (a: any, b: any) => {
        const dateA = new Date(a.Notice_Date).getTime();
        const dateB = new Date(b.Notice_Date).getTime();
        return dateA - dateB;
      },
    },
    {
      title: "Resignation Date",
      dataIndex: "Resignation_Date",
      render: (text: string) => {
        if (!text) return "-";
        const date = new Date(text);
        date.setDate(date.getDate());
        return formatDate(date, config);
      },
      sorter: (a: any, b: any) => {
        const dateA = new Date(a.Resignation_Date).getTime();
        const dateB = new Date(b.Resignation_Date).getTime();
        return dateA - dateB;
      },
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div className="action-icon d-inline-flex">
          <Link
            to="#" data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={!canEdit ? "Permission Denied" : "Edit"}
            onClick={(e) => { e.preventDefault(); if (!canEdit) return; setIsEditing(true); handleEdit(record); setIsDrawerVisible(true); }}
            style={{ cursor: canEdit ? "pointer" : "not-allowed", opacity: canEdit ? 1 : 0.5, pointerEvents: canEdit ? "auto" : "none", }}
          >
            <i className="ti ti-edit" />
          </Link>

          <Link
            to="#"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={!canDelete ? "Permission Denied" : record.Status === "inactive" ? "Item is inactive" : "Delete"}
            onClick={(e) => {e.preventDefault(); if (!canDelete || record.Status === "inactive") return;setSelectedRowData(record);setIsDeleteModalVisible(true);}}
            style={{cursor: !canDelete || record.Status === "inactive" ? "not-allowed" : "pointer", opacity: !canDelete || record.Status === "inactive" ? 0.5 : 1, pointerEvents: !canDelete || record.Status === "inactive" ? "none" : "auto",}}
          >
            <i className="ti ti-trash" />
          </Link>
        </div>
      ),
    },
  ];
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Resignation</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Resignation
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              {canAdd && (
                <div className="mb-2">
                  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center"
                    onClick={() => {
                      setIsEditing(false);
                      setIsDrawerVisible(true);
                      setFormData({
                        employee: "",
                        department: "",
                        designation: "",
                        manager: "",
                        hod_id: "",
                        hrId: "",
                        noticeDate: "",
                        resignationDate: "",
                      });
                    }}
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add Resignation
                  </button>
                </div>
              )}
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Resignation List */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <h5 className="d-flex align-items-center">
                    Resignation List
                  </h5>
                  <div className="d-flex align-items-center flex-wrap row-gap-3">
                    <div className="dropdown">
                      <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        {selectedSort
                          ? `Sort By : ${selectedSort}`
                          : "Sort By : Last 7 Days"}
                      </Link>
                      <ul className="dropdown-menu dropdown-menu-end p-3">
                        <li>
                          <Link
                            to="#"
                            onClick={() => setSelectedSort("Recently Added")}
                            className="dropdown-item rounded-1"
                          >
                            Recently Added
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            onClick={() => setSelectedSort("Ascending")}
                            className="dropdown-item rounded-1"
                          >
                            Ascending
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            onClick={() => setSelectedSort("Descending")}
                            className="dropdown-item rounded-1"
                          >
                            Descending
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            onClick={() => setSelectedSort("Last Month")}
                            className="dropdown-item rounded-1"
                          >
                            Last Month
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            onClick={() => setSelectedSort("Last 7 Days")}
                            className="dropdown-item rounded-1"
                          >
                            Last 7 Days
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body p-0">
                  <Table
                    key={tableKey}
                    dataSource={filteredData}
                    columns={columns}
                    Selection={true}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* /Resignation List  */}
        </div>
        {/* Footer */}
        <div className="footer d-sm-flex align-items-center justify-content-between bg-white border-top p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
        {/* /Footer */}
      </div>
      <>
        <Drawer
          title={isEditing ? "Update Resignation" : "Add Resignation"}
          placement="right"
          closable={true}
          onClose={() => setIsDrawerVisible(false)}
          open={isDrawerVisible}
          width={480}
        >
          <form onSubmit={handleSubmit}>
            <div className="modal-body pb-0">
              <div className="row g-3">
                {/* Employee */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Employee <span className="text-danger"> *</span>
                    </label>
                    <Select
                      name="employee"
                      options={formattedEmployees.sort((a: any, b: any) => a.label.localeCompare(b.label))}
                      value={formattedEmployees.find(
                        (opt: any) => opt.value === formData.employee
                      )}
                      onChange={(selected: any) =>
                        handleChange("employee", selected)
                      }
                    />
                  </div>
                </div>

                {/* Department */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Department <span className="text-danger"> *</span>
                    </label>
                    <Select
                      name="department"
                      options={formattedDepartment.sort((a: any, b: any) => a.label.localeCompare(b.label))}
                      value={formattedDepartment.find(
                        (opt: any) => opt.value === formData.department
                      )}
                      onChange={(selected: any) =>
                        handleChange("department", selected)
                      }
                    />
                  </div>
                </div>

                {/* Designation */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Designation <span className="text-danger"> *</span>
                    </label>
                    <Select
                      name="designation"
                      options={formattedDegination.sort((a: any, b: any) => a.label.localeCompare(b.label))}
                      value={formattedDegination.find(
                        (opt: any) => opt.value === formData.designation
                      )}
                      onChange={(selected: any) =>
                        handleChange("designation", selected)
                      }
                    />
                  </div>
                </div>

                {/* Reporting Manager */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Reporting Manager <span className="text-danger"> *</span>
                    </label>
                    <Select
                      name="manager"
                      options={formattedEmployees.sort((a: any, b: any) => a.label.localeCompare(b.label))}
                      value={formattedEmployees.find(
                        (opt: any) => opt.value === formData.manager
                      )}
                      onChange={(selected: any) =>
                        handleChange("manager", selected)
                      }
                    />
                  </div>
                </div>
                {/* HOD */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      HOD <span className="text-danger"> *</span>
                    </label>
                    <Select
                      name="hod_id"
                      options={formattedHOD.sort((a: any, b: any) => a.label.localeCompare(b.label))}
                      value={formattedHOD.find((opt: any) => opt.value === formData.hod_id || null)}
                      onChange={(selected: any) => handleChange("hod_id", selected)}
                    />
                  </div>
                </div>
                {/* HR */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      HR <span className="text-danger"> *</span>
                    </label>
                    <Select
                      name="hrId"
                      options={formattedHr.sort((a: any, b: any) => a.label.localeCompare(b.label))}  
                      value={formattedHr.find((opt: any) => opt.value === formData.hrId || null)}
                      onChange={(selected: any) => handleChange("hrId", selected)} 
                    />
                  </div>
                </div>

                {/* Notice Date */}
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">
                      Notice Date <span className="text-danger"> *</span>
                    </label>
                    <div className="input-icon-end position-relative">
                      <DatePicker
                        name="noticeDate"
                        className="form-control"
                        selected={formData.noticeDate}
                        onChange={(date) => handleChange("noticeDate", date)}
                        dateFormat="dd-MM-yyyy"
                      />
                      <span className="input-icon-addon">
                        <i className="ti ti-calendar text-gray-7" />
                      </span>
                    </div>
                  </div>
                </div>

                {/* Resignation Date */}
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">
                      Resignation Date <span className="text-danger"> *</span>
                    </label>
                    <div className="input-icon-end position-relative">
                      <DatePicker
                        name="resignationDate"
                        className="form-control"
                        selected={formData.resignationDate}
                        onChange={(date) => handleChange("resignationDate", date)}
                        dateFormat="dd-MM-yyyy"
                      />
                      <span className="input-icon-addon">
                        <i className="ti ti-calendar text-gray-7" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-white border me-2"
                onClick={() => {
                  setIsDrawerVisible(false);
                  setFormData({
                    employee: "",
                    department: "",
                    designation: "",
                    manager: "",
                    hod_id: "",
                    noticeDate: "",
                    resignationDate: "",
                    createdBy: user?.UserId,
                  });
                }}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary"
                disabled={isLoading}>
                {isLoading && <span className="spinner-border spinner-border-sm me-2" />}
                {isEditing ? "Update Resignation" : "Add Resignation"}
              </button>
            </div>
          </form>
        </Drawer>

        <DeleteModal1
          isVisible={isDeleteModalVisible}
          onClose={() => setIsDeleteModalVisible(false)}
          onConfirm={() =>
            selectedRowData?.Id && handleDelete(selectedRowData.Id)
          }
        />
      </>
    </>
  );
};

export default Resignation;